export const getOverviewAttributes = () => [
    [
        {
            name: 'fileName',
            label: 'Name',
            display: true,
        },
    ],
    // [
    //     {
    //         // name: 'fileName',
    //         // label: 'Name',
    //         // display: true,
    //     },
    // ],
    // Column 1
    [
        {
            name: 'csvInboxTypeName',
            label: 'InboxType',
            display: true,
        },
    ],
    // Column 2
    [
        {
            name: 'categoryName',
            label: 'Category',
            display: true,
        },
        // {
        //     name: 'processTime',
        //     label: 'ElapsedTime',
        //     display: true,
        // },
    ],
    // Column 3
    [
        {
            name: 'ticketNumber',
            label: 'TicketNumber',
            display: true,
        },
        // {
        //     name: 'comments',
        //     label: 'Comments',
        //     display: true,
        //     colSpan: 2,
        // },
    ],
    // Column 4
    [
        {
            name: 'createdByFriendlyName',
            label: 'UploadedBy',
            display: true,
            component: {
                componentName: 'SubjectType',
                props: {
                    nameProp: 'createdByFriendlyName',
                    imgSrcProp: 'creatorImageUrl',
                },
            },
        },
    ],
]
